module.exports = __webpack_public_path__ + "img/thank_2021_tip5_small.63e66047.png";